const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const SummaryAggregationQuery: any = {
    GetConsolidationList: Backofficebff + '/v2/PaymentConsolidation/consolidation-list',
    ExportSummaryDetails: Backofficebff + '/v2/PaymentConsolidation/export-summary-details',
    FetchOrderSummaryDetail: Backofficebff + '/v2/PaymentConsolidation/fetch-order-summary-detail',
};
